// extracted by mini-css-extract-plugin
export var assigneeBadge = "_lh-0";
export var assigneeDetails = "_lh-1";
export var assigneeInfo = "_lh-2";
export var dropdownContainer = "_lh-4";
export var dropdownImage = "_lh-5";
export var editAssigneeInfo = "_lh-3";
export var editAssigneeModalContainer = "_lh-6";
export var hidden = "_lh-8";
export var input = "_lh-7";